import './styles/simonsLayout.css';
import LoadLinkData from "./LoadLinkData";

export default function NavigateSKPortal() {
    return (<div id="navGamma" className="sidebox">
        <LoadLinkData formedName={"/data/portaldata.json"}/>
    </div>);
}
